import { SystemService } from './../service/system.service';
import { ViewChild } from '@angular/core';
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE SELECTOR TEMPLATE_URL AND CLASS NAME*/
import { Component, OnInit, Input, Renderer2 } from '@angular/core'

/**
* Model import Example : 
* import { HERO } from '../models/hero.model.ts';
*/

@Component({
  selector: 'bh-vscharts',
  templateUrl: './vscharts.template.html'
})

export class vschartsComponent implements OnInit {


  @Input() chartData: any = {};
  @Input() chartTitle: any = '';
  @Input() chartYAxisLabel: any = '';
  @Input() chartXAxisLabel: any = '';
  @Input() yMax: any = 0;
  @Input() yMin: any = 0;

  @ViewChild('chartEl') chartEl: any;

  yHighlightRanges: any = [{
    begin: 0,
    end: 100,
    color: 'rgba(46,139,87, 0.1)'
  }, {
    begin: -100,
    end: 0,
    color: 'rgba(255, 0, 0, 0.1)'
  }]


  options: any = {
    "animation": {
      "duration": 0
    },
    "title": {
      "display": true,
      "text": "",
      "fontSize": 20
    },
    "responsive": true,
    'maintainAspectRatio': false,
    "bApplyBackgroundColor": true,
    "showAllTooltips": true,
    "legend": {
      "display": false
    },
    "yHighlightRanges": [
      {
        "begin": 0,
        "end": -716,
        "color": "rgba(255,0,0, 0.4)"
      },
      {
        "begin": 881,
        "end": 0,
        "color": "rgba(0,255,0, 0.4)"
      }
    ],
    "tooltips": {
      "callbacks": {},
      "bodyFontSize": 10,
      "displayColors": false,
    },
    "scales": {
      "yAxes": [
        {
          "scaleLabel": {
            "display": true,
            "labelString": "",
            "fontSize": 20
          },
          "ticks": {
            "max": 881,
            "min": -716
          }
        }
      ],
      "xAxes": [
        {
          "scaleLabel": {
            "display": true,
            "labelString": "",
            "fontSize": 20
          },
          "ticks": {}
        }
      ]
    }
  }

  height: any = 100;
  width: any = 100;
  systemS: SystemService;

  constructor(private renderer: Renderer2) {
    this.systemS = new SystemService();
  }

  ngOnInit() {
    if (this.yMax === this.yMin) {
      if (this.yMax < 0) {
        this.yMax = 0;
      }
      if (this.yMin > 0) {
        this.yMin = 0;
      }
    }

    if (this.isKitKat()) {
      this.options['maintainAspectRatio'] = true;
    }
    const appliedYMin = Math.round(this.yMin) !== 0 ? Math.round(this.yMin) - 50 : Math.round(this.yMin);
    const appliedYMax = Math.round(this.yMax) !== 0 ? Math.round(this.yMax) + 50 : Math.round(this.yMax);
    // for applying colors
    this.options['yHighlightRanges'][0]['end'] = appliedYMin;
    this.options['yHighlightRanges'][1]['begin'] = appliedYMax;

    // for applying title
    this.options['title']['text'] = this.chartTitle;

    // for scale axex labels
    this.options['scales']['yAxes'][0]['scaleLabel']['labelString'] = this.chartYAxisLabel ? this.chartYAxisLabel : '';
    this.options['scales']['xAxes'][0]['scaleLabel']['labelString'] = this.chartXAxisLabel ? this.chartXAxisLabel : '';

    // yMax and yMin assignment
    this.options['scales']['yAxes'][0]['ticks']['max'] = appliedYMax;
    this.options['scales']['yAxes'][0]['ticks']['min'] = appliedYMin;

    this.options['tooltips']['callbacks']['label'] = function (tooltipItem, data) {
      if (data && data['datasets'] && data['datasets'][tooltipItem['datasetIndex']]
        && data['datasets'][tooltipItem['datasetIndex']].label) {
        return data['datasets'][tooltipItem['datasetIndex']].label;
      }
      return '';
    }
  }

  isKitKat() {
    if (this.systemS.deviceType !== 'browser') {
      if (window['device'] && window['device'].version.split('.')[0] === '4') {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/vschartsComponent/vscharts.component.ts